/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 */
import { addLocaleData } from "react-intl";
import enLocaleData from "react-intl/locale-data/en";
import enTranslationMessages from "./translations/en.json";

addLocaleData(enLocaleData);

const DEFAULT_LOCALE = "en";

// prettier-ignore
const appLocales = ['en'];

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(
    (formattedMessages, key) =>
      flattenFormattedMessages(formattedMessages, key),
    {}
  );
};

const translationMessages = {
  en: formatTranslationMessages("en", enTranslationMessages),
};

export {
  DEFAULT_LOCALE,
  appLocales,
  formatTranslationMessages,
  translationMessages,
};
